import {
  GAP_DEFINITIONS,
  getGapRelatedType,
} from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/section-gaps/section-gap-calculators';
import {
  getMultiSectionFigmaLayout,
  pushGapToColumn,
} from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/sections.common';
import { addHeaderColumns2 } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/header/headerColumns2/addHeaderColumns2';
import { addHeaderColumns3 } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/header/headerColumns3/addHeaderColumns3';
import { addHeaderFullWidth } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/header/headerFullWidth/addHeaderFullWidth';

import type { ViewData } from '../common/multisection.data';
import { getCard } from '@Components/BigBrowse/Model/Classes/GridCard';
import { PlaneTypes } from '@Components/BigBrowse/Model/ModelTypes';
import {
  FIGMA_TOP_PADDING_FULL_WIDTH,
  FIGMA_TOP_PADDING_MOBILE,
} from '../common/multisection.figma';

export async function addHeader(viewData: ViewData): Promise<ViewData> {
  const { layoutTable } = viewData;
  const columns = layoutTable!.length;
  let updatedViewData = viewData;
  updatedViewData = addHeaderBg(viewData);
  updatedViewData = addHeaderTopPadding(viewData);

  if (columns > 3) {
    await addHeaderFullWidth(updatedViewData);
  } else if (columns === 3) {
    await addHeaderColumns3(updatedViewData);
  } else {
    await addHeaderColumns2(updatedViewData);
  }

  await addHeaderBottomPadding(updatedViewData);
  updatedViewData = addHeaderBackgroundMarker(updatedViewData);

  return updatedViewData;
}

export function addHeaderTopPadding(viewData: ViewData): ViewData {
  const { layoutTable } = viewData;
  const height =
    getMultiSectionFigmaLayout(viewData) === 'full'
      ? FIGMA_TOP_PADDING_FULL_WIDTH
      : FIGMA_TOP_PADDING_MOBILE;

  layoutTable?.forEach(pushGapToColumn(height, viewData));
  return viewData;
}

const addHeaderBg = (viewData: ViewData) => {
  if (!viewData.layoutTable?.[0]) {
    return viewData;
  }

  // Note: PlaneTypes.Header_Background cards do not actually participate in the layout flow
  // They are just rendered in background of the view
  const concessionId = viewData.modelData.concessionId;
  const headerBgCard = getCard<PlaneTypes.Header_Background>({
    data: {
      ...viewData.modelData.header,
      key: `header-bg-${concessionId}`,
      concessionId: concessionId,
    },
    type: PlaneTypes.Header_Background,
    size: { width: viewData.layoutWidth!, height: 0 },
  });

  headerBgCard.key = `header-bg-${concessionId}`;
  viewData.layoutTable[0].push(headerBgCard);
  return viewData;
};

function addHeaderBackgroundMarker(viewData: ViewData): ViewData {
  const concessionId = viewData.modelData.concessionId;
  const card = getCard<PlaneTypes.Header_Background_Marker>({
    data: {
      ...viewData.modelData.header,
      key: `header-bg-${concessionId}`,
      concessionId: concessionId,
    },
    type: PlaneTypes.Header_Background_Marker,
    size: { width: viewData.layoutWidth!, height: 0 },
  });
  card.key = `header-bg-marker-${concessionId}`;
  viewData.layoutTable?.[0]?.push(card);

  return viewData;
}

async function addHeaderBottomPadding(viewData: ViewData): Promise<ViewData> {
  const result = viewData;

  const firstSection = viewData.modelData.sections?.[0];
  if (!firstSection) {
    return viewData;
  }

  const firstSectionGapType = getGapRelatedType(
    firstSection ?? { template: 'NotSet' }
  );

  let gapHeight = GAP_DEFINITIONS.Header[firstSectionGapType] ?? 0;

  // if first section IS HeroAndText with Hero image, then WE have to apply all the gap between us
  if (
    firstSection.template === 'HeroAndText' &&
    firstSectionGapType !== 'NoHeroText'
  ) {
    gapHeight = gapHeight * 2; // we double the padding, so it applies x1 at the end of the function
  }

  result.layoutTable?.forEach(pushGapToColumn(gapHeight / 2, viewData, 'pink'));

  return result;
}
